const locale = {
  COMMON: {
    TITLE_LOGIN: '登录',
    COLH_ACCT_NO: '账号',
    COLH_EMAIL: '邮箱',
    COLH_CHECK_EMAIL: '确认邮箱',
    TXT_ACCOUNT_DESC: '请输入账号',
    COLH_CIPHER: '密码',
    COLH_HELP_DOC: '帮助文档',
    TXT_CIPHER_DESC: '请输入密码',
    BTN_FORGET_CIPHER: '忘记密码',
    BTN_LOGIN: '登录',
    BTN_LOGIN_ING: '正在登录中...',
    BTN_BACK_TO_LOGIN: '返回登录',
    BTN_RETURN: '返回',
    BTN_SUBMIT: '提交',
    TITLE_MENUGROUP: '菜单组',
    TITLE_PURVIEW_POINT: '权限点',
    TITLE_AVAILABLE_STRUCTURE: '可见组织结构',
    LABEL_OPERATION: '操作',
    ENABLE: '已启用',
    DISABLE: '已禁用',
    MSG_SERVER_ERROR: '系统错误，请联系管理员',
    MSG_NO_PERMISSION: '对不起，你暂无此页面访问权限，请联系管理员',
    MSG_ASSIGN_SUCCESS: '角色分配成功',
    MSG_ASSIGN_STRUCTURE_SUCCESS: '组织结构分配成功',
    MSG_ASSIGN_USER_GROUP_SUCCESS: '用户组分配成功',
    ERRMSG_NO_PERMISSION: '你的账号无访问权限，即将跳转至首页',
    TITLE_NO_PERMISSION: '访问被拒绝',
    TITLE_ERROR: '错误',
    BTN_MANAGE: '管理',
    BTN_DELETE: '删除',
    BTN_REMOVE: '移除',
    BTN_CANCEL: '取消',
    BTN_CONFIRM: '确认',
    PRMTMSG_DELETE_SUCCEED: '操作成功',
    LABEL_NAME: '名称',
    BTN_EDIT: '编辑',
    PRMTMSG_NAME_NOT_REPEAT: '名称不可重复',
    HINT_INPUT_PLACEHOLDER: '请输入', // 删除
    NO_CONTENT: '暂无数据',
    INLINE_NEEDED: '不可为空',
    INLINE_NAME_MAX_LENGTH: '长度不可超过20',
    FORMMSG_INPUT: '描述不能为空',
    BTN_LOGOUT: '退出',
    BTN_SWITCH_OU: '切换企业',
    TITLE_SWITCH_OU: '请选择进入的企业/组织',
    BTN_CHANGE_CIPHER: '修改密码',
    BTN_RENAME: '重命名',
    BTN_I_SEE: '我知道了',
    TITLE_DELETE_FAIL: '删除失败',
    NOT_FOUND1: '未找到访问页面',
    NOT_FOUND2: '对不起，你无法访问该页面',
    NOT_FOUND_MOBILE: '您暂时没有应用权限',
    NO_AUTH1: '没有访问权限',
    NO_AUTH2: '对不起，您暂时没有应用访问权限，',
    NO_AUTH3: '请联系管理员',
    NOT_AUTH_MOBILE: '对不起，您暂时没有应用访问权限',
    TITLE_ADD_FAIL: '新增失败',
    TITLE_MODIFY_FAIL: '修改失败',
    TITLE_WELCOME: '欢迎加入',
    COLH_DESCRIPTION: '描述',
    TXT_NO_ROLE: '暂无角色 请前往角色管理中创建或联系系统管理员创建',
    NO_DATA: '无匹配结果',
    PRMTMSG_EXIST_NAME: '名称已被占用',
    MSG_ACCOUNT_REQUIRED: '账号不能为空',
    MSG_SOURCE_REQUIRED: '来源不能为空',
    MSG_FILE_TYPE_LIMIT: '上传图片格式不支持',
    MSG_FILE_SIZE_LIMIT: '图片大小不能超过2M',
    MSG_TOKEN_EXPIRED: '初始化或重置信息已过期',
    HINT_INVALID_PUBLIC_KEY: '登录失败，请刷新页面后重试',
    TXT_COPY_RIGHT: 'Powered by EnOS',
    TXT_COPY_RIGHT1: ' Powered by EnOS',
    BTN_LAN_SWITCH: '切换语言',
    BTN_CHANGE_ORGANIZATION: '切换组织/企业',
    TITLE_SETTING: '设置',
    TITLE_CHANGE_CIPHER: '修改密码',
    TXT_CHANGE_CIPHER_NOTE: '为了你的账号安全，请立即修改密码',
    TITLE_SELECT_ORGANIZATION: '选择进入的企业',
    TITLE_MENUBAR: '菜单',
    BTN_EXPAND: '展开',
    BTN_COLLAPSE: '收起',
    TITLE_SESSION_CONFLICT: '你的账号在其他地方登录',
    TXT_SESSION_CONFLICT:
      '你的账号已经在其他地方登录，登录IP：{0}。 你已退出登录。',
    BTN_CHANGE_THEME: '切换导航栏肤色',
    TITLE_CHANGE_THEME: '切换导航栏肤色',
    TXT_CHANGE_THEME_HINT: '选中肤色后，导航栏即可变换肤色',
    TXT_DARK_THEME: '深色',
    TXT_BLUE_THEME: '蓝绿色',
    TITLE_TOKEN_EXPIRED: '登录失效',
    TXT_EXPIRED_CONTENT: '由于你长时间未操作，为保证账号安全，系统已自动登出',
    TITLE_MULTI_LANGUAGE: '多语言',
    BTN_MORE: '更多',
    BTN_HIDE: '收起',
    BTN_ADMIN: '管理员',
    TITLE_ADMIN_INFO: '管理员信息',

    TXT_LANGUAGE_EN: '英语(en-US)',
    TXT_LANGUAGE_ZH: '中文(zh-CN)',
    TXT_LANGUAGE_JA: '日语(ja-JP)',
    TXT_LANGUAGE_ES: '西班牙语(es-ES)'
  },
  ROLE: {
    TITLE_ROLE_MANAGE: '角色',
    BTN_ADD_NEW_ROLE: '新建角色',
    HINT_SEARCH_BY_ROLE: '输入角色名称查找',
    COLH_NAME: '角色名称',
    COLH_DESCRIPTION: '描述',
    COLH_OPERATE: '操作',
    COLH_KEY_WORD: '关键字',
    FORMMSG_ROLE_MANAGE: '管理',
    FORMMSG_ROLE_DELETE: '删除',
    FORMMSG_ROLE_REMOVE: '移除',
    TITLE_ADDROLE: '新建角色',
    TITLE_CHOOSE_APP: '第一步：选择应用',
    TITLE_MODIFYROLE: '编辑角色',
    TITLE_DELETE_ROLE: '删除角色失败',
    TITLE_CONFIRM_ROLE: '删除角色',
    LABEL_ADDROLE_NAME: '名称',
    LABEL_ADDROLE_DESCRIPTION: '描述',
    LABEL_MENUGROUP_NAME: '菜单组名称',
    LABEL_PERMISSION_NAME: '权限点名称',
    LABEL_PERMISSION_DESC: '权限点描述',
    LABEL_BELONG_APP: '所属应用',
    TITLE_DELETE_FAIL: '删除失败',
    BTN_CANCEL: '取消',
    BTN_EDIT: '编辑',
    BTN_SUBMIT: '提交',
    BTN_CONFIRM: '确认',
    BTN_CHECK: '确定',
    BTN_ASSIGNMENT_MENGROUP: '分配菜单组',
    BTN_ASSIGNMENT_PURVIEW_POINT: '分配权限点',
    TITLE_ASSIGNMENT_MENGROUP: '第二步：选择菜单组',
    TITLE_ASSIGNMENT_PURVIEW_POINT: '第二步：选择权限点',
    PRMTMSG_ADDROLE_SUCCESS: '新建角色成功',
    PRMTMSG_DELROLE_SUCCESS: '删除角色成功',
    PRMTMSG_EXIST_ROLE: '角色名称已被占用',
    PRMTMSG_MODROLE_SUCCESS: '修改角色成功',
    PRMTMSG_REMMGROUP_SUCCESS: '菜单组移除成功',
    HINT_ADD_ROLE_PLACEHOLDER: '请输入角色名称',
    HINT_ADD_ROLE_DESCRIPTION_PLACEHOLDER: '请输入角色描述',
    PRMTMSG_ASSMGROUP_SUCCESS: '菜单组分配成功',
    PRMTMSG_ASSPERMISSION_SUCCESS: '权限点分配成功',
    PRMTMSG_REMPERMISSION_SUCCESS: '权限点移除成功',
    WINMSG_ROLEDELETE_FAIL: '该角色已绑定用户，无法删除',
    WINMSG_CHECK: '关闭',
    WINMSG_DELETE_CHECK: '删除角色后，相关权限也会被解除。确认删除角色？',
    BTN_FORGET_CIPHER: '忘记密码',
    TXT_SELECTED_APP: '已选应用',
    INLINE_NAME_HINT: '名称最大长度为20字符，且不可重复',
    MSG_ACCOUNT_REQUIRED: '角色名称不能为空',
    WINMSG_MENUGRP_DELETE_CHECK:
      '移除菜单组后，该角色将失去该菜单组相关权限。确定移除菜单组？',
    HOVER_ROLE_MENUGRP:
      '菜单组是应用内菜单的集合，可以组合菜单形成菜单组，将菜单组分配给角色，角色即拥有了菜单组内菜单的访问权限。',
    HOVER_ROLE_PERMISSION:
      '权限点是应用内命名的，有特定操作的权限名称，将权限点分配给角色后，该角色的用户具备相应的权限点操作能力。',
    WINMSG_PERMISSION_DELETE_CHECK:
      '移除权限点后，该角色将失去该权限点相关权限。确认移除权限点？',
    TITLE_DELETE_PERMISSION: '移除权限点',
    WINMSG_APP_NO_PERMISSION: '该应用暂无权限点',
    WINMSG_APP_NO_MENUGROUP: '该应用暂无菜单组',
    TITLE_DELETE_MENUGROUP: '移除菜单组',
    TITLE_ASSGIN_MENU_GROUP: '分配菜单',
    TITLE_ROLE_DETAIL: '角色详情',
    COLH_CREATE_BY: '创建人',
    COLH_CREATE_TIME: '创建时间',
    HOVER_ROLE_STRUCTURE: '配置角色可见的组织结构，分配成功后，具有该角色的用户即可拥有已分配的组织结构的可见权限。',
    BTN_ASSIGNMENT_STRUCTURE: '分配组织结构',
    LABEL_STRUCTURE_NAME: '组织结构名称',
    TITLE_DELETE_STRUCTURE: '移除可见组织结构',
    WINMSG_STRUCTURE_DELETE_CHECK: '移除可见组织结构后，该角色将失去该组织结构相关权限，确定移除可见组织结构？',
    PRMTMSG_REMSTRUCTURE_SUCCESS: '可见组织结构移除成功',
    WINMSG_APP_NO_STRUCTURE: '该应用暂无已分配的组织结构',
    TITLE_ASSIGNMENT_STRUCTURE: '第二步：选择组织结构',
    PRMTMSG_ASSSTRUCTURE_SUCCESS: '可见组织结构分配成功'
  },
  USERGROUP: {
    TITLE_PAGENAME: '用户组',
    BTN_ADD_USER_GROUP: '新建用户组',
    TITLE_ADD_USER_GROUP: '新建用户组',
    COLH_NAME: '用户组名称',
    COLH_DESCRIPTION: '描述',
    LABEL_NAME: '名称',
    LABEL_DESCRIPTION: '描述',
    INLINE_NAME_HINT: '名称最大长度为20字符，且不可重复',
    BTN_OKTEXT: '提交',
    BTN_OKCONFIRM: '确认',
    BTN_CANCELTEXT: '取消',
    PRMTMSG_ADD_SUCCEED: '新建用户组成功',
    TITLE_MODIFY_USER_GROUP: '编辑用户组',
    WINMSG_DELETE_HINT: '删除用户组后，相关权限也将被解除。确认删除用户组？',
    PRMTMSG_DELETE_SUCCEED: '用户组删除成功',
    BTN_OKTEXT_IKNOW: '关闭',
    HINT_SEARCH_USER_GROUP: '输入用户组名称查询',
    TITLE_CONFIRM_DELETE: '删除用户组',
    INLINE_DESCRIPTION_MAX_LENGTH: '长度不可超过50字符',
    PRMTMSG_MODIFY_SUCCEED: '用户组编辑成功',
    HINT_ADD_USER_GROUP_PLACEHOLDER: '请输入用户组名称',
    HINT_ADD_USER_GROUP_DESCRIPTION_PLACEHOLDER: '请输入用户组描述',
    MSG_USER_GROUP_NAME_NEEDED: '用户组名称不可为空',
    MSG_USER_GROUP_DESCRIPTION_NEEDED: '描述不可为空',

    BTN_VIEW: '查看',
    COLH_ASSIGNED_USER: '已分配用户',
    COLH_CREATE_BY: '创建人',
    COLH_CREATE_TIME: '创建时间'
  },
  MENU: {
    BTN_APP_MGR: '应用管理',
    BTN_USER_PERMISSION: '用户与权限',
    BTN_USER_MGR: '用户',
    BTN_ROLE_MGR: '角色',
    BTN_USER_GROUP_MGR: '用户组',
    BTN_STRUCTURE_MGR: '组织结构',
    BTN_SUB_ADMIN_MGR: '子管理员设置',
    BTN_ASSET_PERMISSION_MGR: '资产权限分配',
    BTN_OTHER_MGR: '其他设置',
    BTN_ASSET_MGR: '资产管理',
    BTN_OU_CONF: 'OU设置',
    BTN_ASSET_SYN: '资产同步',
    BTN_ASSET_TREE: '资产树',
    BTN_OU_MGR: 'OU管理员',
    BTN_PLUGIN_MGR: '插件管理',
    BTN_OU: 'OU',
    BTN_DOMAIN: '域配置',
    BTN_SECURITY_SETTING: '安全设置',
    BTN_ACCOUNT_PROTECTION: '账号保护',
    BTN_SECURITY_MGR: '安全管理',
    BTN_AUDIT_LOG: '审计记录'
  },
  MENU_GROUP: {
    BTN_ADD_MENU_GROUP: '新建菜单组',
    DEFAULT_MENU_GROUP: '默认菜单组',
    TITLE_ADD_MENU_GROUP: '新建菜单组',
    PRMTMSG_ADD_SUCCEED: '菜单组新建成功',
    TITLE_MODIFY_MENU_GROUP: '重命名菜单组',
    PRMTMSG_MODIFY_SUCCEED: '菜单组重命名成功',
    TITLE_CONFIRM_DELETE: '删除菜单组',
    WINMSG_DELETE_HINT:
      '删菜单组后，与菜单组的绑定关系也将被解除。确认删除菜单组？',
    PRMTMSG_DELETE_SUCCEED: '删除菜单组成功',
    TITLE_ASSGIN_MENU_GROUP: '配置菜单',
    BTN_ASSGIN_MENU_GROUP: '配置菜单',
    TXT_MENU_GROUP: '菜单组',
    TXT_ASSGIN_MENU: '已配置菜单'
  },
  APP: {
    COLH_NAME: '应用名称',
    TITLE_CATEGORY: '应用分类',
    TITLE_PAGENAME: '应用',
    COLH_STATUS: '启用',
    COLH_STRUCTURE: '应用展示组织结构',
    HINT_ASSIGN_STRUCTURE: '分配组织结构',
    TITLE_ASSIGN_STRUCTURE: '分配组织结构',
    MANAGE_MENU_GROUP: '管理菜单组',
    TITLE_ClOSE_APP_STATUS: '禁用应用',
    TITLE_OPEN_APP_STATUS: '启用应用',
    WINMSG_ClOSE_APP_STATUS_HINT:
      '禁用后，全部人员在应用切换列表将看不到该应用，但不改变使用权限.',
    WINMSG_OPEN_APP_STATUS_HINT:
      '启用后，对该应用有权限的用户将能在应用切换列表看到该应用，确认启用？',
    HINT_CHANGE_STRUCTURE: '更换组织结构',
    TITLE_APP_MANAGE: '应用管理',
    BTN_SORT: '排序',
    TXT_SORT_WARNING: '调整分类及应用排序后，切换应用下拉列表中的应用将会按照此顺序排列',
    HINT_CAN_NOT_SORT: '暂无应用，无法排序',
    BTN_CREATE_SHORTCUT_APP: '创建快捷方式',
    BTN_MGR_SHORTCUT_APP: '管理',
    BTN_DELETE_SHORTCUT_APP: '删除',
    TITLE_SHORTCUT: '快捷方式',
    TITLE_DELETE_SHORTCUT_MODAL: '删除快捷方式',
    CONTENT_DELETE_SHORTCUT_MODAL: '快捷方式删除后不可恢复，确认删除？',
    MSG_DELETE_SHORTCUT_SUCCESS: '快捷方式删除成功',
    TXT_SHORTCUT_DETAIL: '快捷方式详情',
    TITLE_ADD_SHORTCUT_FAIL: '创建快捷方式失败',
    MSG_ADD_SHORTCUT_SUCCESS: '快捷方式创建成功',
    COLH_MAIN_APP: '主体应用',
    COLH_APP_NAME: '名称',
    COLH_NAME_ZH: '名称（中文）',
    COLH_NAME_EN: '名称（英文）',
    COLH_CATEGORY: '应用分类',
    COLH_DESCRIPTION: '描述',
    TITLE_MODIFY_BASIC_INFO: '编辑基本信息',
    MESSAGE_MODIFY_SUCCEED: '编辑成功',
    TITLE_ADDED_APP: '已添加菜单',
    BTN_ADD_MENU: '添加菜单',
    TXT_ADD_FROM_OTHER_APP: '从其他应用获取',
    TXT_ADD_FIRST_CLASS_MENU: '新建一级菜单',
    TITLE_CHOOSE_APP: '第一步，选择应用',
    TITLE_ASSIGN_MENU: '第二步，选中菜单',
    HINT_ADD_SUB_MENU: '添加下级菜单',
    HINT_DELETE: '删除',
    HINT_EDIT: '编辑',
    HINT_ADD_MENU_ZH_PLACEHOLD: '请输入中文名称',
    HINT_ADD_MENU_EN_PLACEHOLD: '请输入英文名称',
    TITLE_CONFIRM_DELETE: '删除菜单',
    TXT_CONFIRM_DELETE: '菜单删除后不可恢复，确认删除？',
    TITLE_CONFIRM_DELETE_AGAIN: '删除该一级菜单及其下的二级菜单',
    HINT_DELETE_MENU_SUCCEED: '菜单删除成功',
    HINT_CREATE_MENU_SUCCEED: '新建菜单成功',
    HINT_ADD_MENU: '可添加其他应用的菜单，添加成功后，可通过授权提供给用户使用',
    WINMSG_APP_NO_MENU: '暂无可选菜单',
    TXT_SOURCE: '来源',
    BTN_API_AUTHORIZATION: '接口权限授权',
    MSG_API_AUTHORIZATION: '接口授权',
    TXT_API_AUTHORIZATION: '授于应用通过接口执行以下操作的权限',
    TXT_API_AUTHORIZATION_USER: '获取本 OU 内所有用户 ID、账号、邮箱、手机号码',
    TXT_API_AUTHORIZATION_ASSET: '获取本 OU 内所有资产 ID、名称',
    MSG_API_AUTHORIZATION_SUCCESS: '已更新接口数据权限',
    BTN_VIEW_MENU: '查看菜单',
    BTN_SORT_MENU: '菜单排序',
    TXT_SORT_MENU_WARNING:
      '排序调整后，点击【提交】按钮，用户重新登录后，菜单排序即可生效',
    HINT_MODIFY_MENU_SUCCESS: '菜单重命名成功',
    HINT_SORT_MENU_SUCCESS: '菜单排序成功',
    MESSAGE_ADD_NEEDED: '请输入菜单名称', // 更新
    MESSAGE_RENAME_NEEDED: '请输入快捷方式名称', // 更新
    MESSAGE_RENAME_MENU_GROUP_NEEDED: '请输入菜单组名称', // 更新
    HINT_SORT_APP_SUCCESS: '排序成功',
    HINT_ASSIGN_APP_STRUCTURE: '组织结构分配成功',
    MSG_ADD_MENU_SUCCESS: '菜单添加成功',
    MSG_SHORTCUT_NAME_NEEDED: '快捷方式名称不可为空',
    COLH_NAME_JA: '名称（日语）',
    COLH_NAME_ES: '名称（西班牙语）',
    LABEL_URL: 'URL',
    TXT_API_AUTHORIZATION_ROLE: '获取本 OU 内所有角色 ID，名称',
    WINMSG_APP_NO_PERMISSION: '暂无可选权限点',
    TITLE_DELETE_PERMISSION: '删除权限点',
    WINMSG_PERMISSION_DELETE_CHECK:
    '删除权限点后，该应用快捷方式将失去该权限点相关权限。确认删除权限点？',
    TITLE_ADDED_PER: '已添加权限点',
    BTN_ASSIGNMENT_PURVIEW_POINT: '添加权限点',
    HINT_ADD_PER: '可添加其他应用的权限点，添加成功后，可通过授权提供给用户使用',
    PRMTMSG_ASSPERMISSION_SUCCESS: '权限点添加成功',
    PRMTMSG_REMPERMISSION_SUCCESS: '权限点删除成功',
    TITLE_DOWNLOAD_NAME: '用户列表',
    TXT_STRUCTURE_SELECT: '最多选择{0}个组织结构',
    TITLE_UNBIND: '移除已分配组织结构',
    WINMSG_UNBIND: '组织结构已关联角色，一旦移除，将会导致用户角色无法获取该组织结构的可见权限，请谨慎操作。',
    NO_STRUCTURE: '暂无可用的组织结构，请前往创建',
    BTN_ALL_APP: '全部应用',
    BTN_PURCHASED_APP: '已购买应用',
    BTN_SELFDESIGNED_APP: '自建应用',
    COLH_NEWNAVIGATION: '新版导航',
    TXT_NEWNAVIGATION: '注意: 若不开启新版导航，应用将保持现有的旧版导航样式',
    TITLE_OLDNAVIGATION: '旧版导航',
    TXT_SHOW_MENU_NAME: '显示菜单名称',
    TXT_SHOW_ICON: '显示图标',
    TXT_FOLDER_SUBMENU: '展开/收起二级菜单',
    TXT_ICON_MENU: '折叠为图标菜单',
    TITLE_CLOSE_NEWNAVIGATION: '确定关闭新版导航？',
    TXT_CLOSE_NEWNAVIGATION: '关闭新版导航将使菜单主题切换到旧版导航，且导致已配置的图标不再显示，请谨慎操作。',
    BTN_APP_MENUMANAGEMENT: '应用菜单管理',
    TXT_MENU_MANAGEMENT: '菜单管理'
  },
  MENU_MANAGEMENT: {
    TXT_SEARCH: '输入名称、标识符查询',
    COLH_MENU_ICON_NAME: '图标/菜单',
    COLH_MENU_CODE: '标识符',
    COLH_ORDER: '排序',
    COLH_URL: 'URL',
    TITLE_ADDITION: '附加信息',
    TITLE_SWITCH: '跳转',
    TITLE_OPEN: '展开',
    TXT_SWITCHMENU: '跳转到此二级菜单',
    TITLE_MENU_NAME: '菜单名称',
    TITLE_MENU_PROPERTY: '菜单属性',
    TITLE_OPEN_SUBMENU: '展开二级菜单',
    TITLE_SWITCH_SUBMENU: '跳转二级菜单',
    TITLE_SELECT_ICON: '选择图标',
    BTN_SAVE: '保存',
    MSG_ICON_SAVE_SUCCESSFULLY: '图标保存成功！'
  },
  STRUCTURE: {
    TITLE_STRUCTURE_MANAGE: '组织结构管理',
    TITLE_MANAGE_STRUCTURE: '管理组织结构',
    BTN_ADD_STRUCTURE: '新建组织结构',
    COLH_NAME: '组织结构名称',
    WINMSG_DELETE_STRUCTURE_HINT: '删除组织结构不可恢复，确认删除该组织结构？',
    TITLE_ADD_STRUCTURE: '新建组织结构',
    PRMTMSG_ADD_SUCCEED: '新建组织结构成功',
    PRMTMSG_ADD_CHILD_SUCCEED: '组织节点添加成功',
    DELETE_STRUCTURE_SUCCEED: '组织结构删除成功',
    INLINE_STRUCTURE_AMOUNT: '最多可新建5个组织结构',
    COLH_AUTO_ASSGIN_STATUS: '自动分配状态',
    TITLE_ClOSE_STRUCTURE_AUTO_DISPATCH: '关闭自动分配',
    TITLE_OPEN_STRUCTURE_AUTO_DISPATCH: '开启自动分配',
    WINMSG_ClOSE_STRUCTURE_AUTO_DISPATCH:
      '关闭自动分配后，系统将不再根据用户所在节点自动分配资产访问权限。确认关闭自动分配？',
    WINMSG_OPEN_STRUCTURE_AUTO_DISPATCH:
      '开启自动分配后，组织结构内的用户将自动获得下级节点的访问权限。确认开启自动分配？',
    BTN_ADD_SUB_NODE: '添加下级节点',
    BTN_MANAGE_ASSET: '管理资产',
    BTN_MANAGE_USER: '查看用户',
    TITLE_ADD_NODE: '添加节点',
    LABEL_NODE_NAME_ZH: '节点名称（中文）',
    LABEL_NODE_NAME_EN: '节点名称（英文）',
    TITLE_CONFIRM_DELETE_STRUCTURE: '删除组织结构',
    TITLE_CONFIRM_DELETE: '删除组织节点',
    WINMSG_DELETE_HINT: '删除组织节点不可恢复，确认删除该组织节点？',
    TITLE_MODIFY_STRUCTURE: '重命名',
    PRMTMSG_ASSIGN_SUCCEED:
      '操作成功，为保证安全，分配资产后，用户将在3分钟后获得相应的资产权限',
    TITLE_MANAGE_USER: '查看用户',
    BTN_SYNC_ASSETS: '同步资产',
    PRMTMSG_SYNC_SUCCEED: '同步资产成功',
    BTN_SYNCING: '同步中...',
    HINT_SYNC_ASSETS_HINT: '点击“同步资产”，完成与已接入资产同步',
    PRMTMSG_MODIFY_SUCCEED: '组织节点编辑成功',
    UNASSIGNED_ASSET: '未分配资产',
    ASSIGNED_ASSET: '已分配资产',
    HINT_ADD_STRUCTURE_PLACEHOLDER: '请输入组织结构名称',
    INLINE_NANME_NEEDED: '节点名称不可为空',
    MSG_STRUCTURE_NAME_NEEDED: '组织结构名称不可为空',
    MSG_STRUCTURE_NAME_PATTERN: '填写内容不能包含符号"," "，"和"|"等',
    INLINE_STRUCTURE_HINT:
      '组织结构是一种以管理单元为节点的资产管理层级关系（如以地理位置设置为层级），将人员分配到组织结构后，可实现组织结构内用户自动获得下级节点访问权限。',
    BTN_USER: '用户',
    BTN_ASSET: '资产',
    LABEL_NAME: '名称',

    BTN_ADD_TAG: '添加标签',
    BTN_EDIT_TAG: '编辑标签',
    LABEL_TAG_ID: '标签键',
    MSG_TAG_ID_INPUT: '仅支持字母、数字、下划线"_"、连字符"-"和斜杠"/"',
    LABEL_TAG_VALUE: '标签值',
    HINT_INPUT_TAG_VALUE: '请输入标签值',
    HINT_INPUT_TAG_ID: '请输入标签键',
    TAB_TAG: '标签',
    TITEL_DELETE_TAG: '删除标签？',
    TXT_DELETE_TAG_HINT: '删除标签删除标签不可恢复，确认删除该标签？',
    PRMTMSG_CREATE_TAG_SUCCEED: '添加标签成功',
    PRMTMSG_MODIFY_TAG_SUCCEED: '编辑标签成功',
    MSG_TAG_KEY_EXIST: '该标签键已被占用',
    MSG_DELETE_STRUCTURE_TAG_SUCCEED: '删除标签成功',
    BTN_SORT: '配置排序',
    MSG_SORT_SUCCESS: '保存成功',
    MSG_SORT_FAILED: '未成功保存',
    MSG_ASSETSORT_FAILED: '操作失败，请重试',
    TXT_SORT_WARNING: '仅支持对同一父节点下的子节点进行拖拽排序，即不能将节点拖拽到不同的父节点。'
  },
  USER: {
    BTN_SEARCH: '搜索',
    TITLE_PAGE_NAME: '用户',
    TITLE_USER_DETAIL: '用户详情',
    TITLE_USER_ROLE: '已分配角色',
    TITLE_USER_STRUCTURE: '所属组织结构',
    TITLE_USER_USER_GROUP: '所属用户组',
    TITLE_MODIFY_USER: '编辑用户',
    BTN_CREATE_USER: '添加用户',
    TITLE_CREATE_USER_FAILED: '添加失败',
    MSG_CREATE_USER_FAILED: '对不起，该用户已存在于该企业/组织中，无法添加',
    BTN_ASSIGN_ROLE: '分配角色',
    TITLE_ASSIGN_ROLE: '分配角色',
    BTN_ASSIGN_STRUCTURE: '分配组织结构',
    TITLE_ASSIGN_STRUCTURE: '分配组织结构',
    BTN_ASSIGN_USER_GROUP: '分配用户组',
    TITLE_ASSIGN_USER_GROUP: '分配用户组',
    TXT_SEARCH: '输入账号或姓名查询',
    BTN_MANAGE: '管理',
    BTN_REMOVE_FROM_OU: '从本企业/组织移除',
    TITLE_REMOVE_FROM_OU: '移除用户',
    MSG_REMOVE_FROM_USER_GROUP: '从用户组移除',
    MSG_REMOVE_FROM_OU: '移除以后，用户将不属于本企业/组织。确认移除用户？',
    MSG_ASSIGN_ROLE: '用户被赋予角色后，将获得角色具有的菜单组和权限点的权限',
    MSG_ASSIGN_USER_GROUP:
      '用户加入用户组后，将同时被赋予用户组相应的资产查看权限',
    MSG_ASSIGN_STRUCTURE:
      '用户加入组织结构后，将同时被赋予组织结构相应的资产查看权限',
    MSG_REMOVE_SUCCESS: '用户移除成功',
    COLH_ACCT_NO: '账号',
    COLH_EMAIL: '邮箱',
    COLH_NICKNAME: '姓名',
    COLH_PHONE: '手机',
    MSG_REMOVE_SELF: '不能移除自己',
    TITLE_CONFIRM_ADD: '添加用户',
    MSG_CONFIRM_ADD_USER: '将添加用户 {0} 至本企业/组织，确认添加？',
    TITLE_MAIL_TO: '发送邀请邮件至:',
    MSG_ENTER_CORRECT_FORMAT: '请输入正确的邮箱格式',
    MSG_EMAIL_NO_RESULT: '未搜索到结果，',
    TITLE_CREATE_JOIN: '新建用户',
    MSG_CREATE_EMAIL_SUCCESS: '账号创建并添加成功，已发送邮件通知该用户',
    MSG_CREATE_EMAIL_NO_EMAIL_SUCCESS: '账号创建并添加成功',
    MSG_ACCOUNT_EXIST: '用户名已存在',
    MSG_ACCOUNT_REQUIRED: '用户名不能为空',
    TXT_ENTER_EMAIL: '请输入邮箱',
    TXT_ENTER_USER_EMAIL: '请输入用户的邮箱', // 添加字段
    MSG_CIPHER_NOT_SAME: '两次输入密码不一致',
    MSG_ENTER_CIPHER: '请输入密码',
    MSG_ENTER_EMAIL_AGAIN: '请再次输入邮箱',
    MSG_ENTER_CIPHER_AGAIN: '请再次输入密码',
    LABEL_CIPHER: '设置密码',
    LABEL_CONFIRM_CIPHER: '确认密码',
    TITLE_RESET_CIPHER: '重置密码',
    BTN_RESET_CIPHER: '重置密码',
    TXT_CONFIRM_RESET_CIPHER: '重置密码',
    MSG_CONFIRM_RESET_CIPHER: '重置密码邮件将发送给用户。确认重置密码？',
    MSG_TRIGGER_RESET_CIPHER: '密码重置邮件已发送',
    MSG_RESET_CIPHER_SUCCESS: '正在自动跳转到登录页面…',
    BTN_REDIRECT_IM: '立即跳转',
    MSG_SEND_RESET_EMAIL_SUCCESSFULLY: '{0}, 有效期24小时',
    MSG_JUMP_TO_MAIL_BOX: '请前往邮箱完成重置',
    BTN_CHANGE_CIPHER_SUCCESSFULLY: '密码设置成功',
    HOVER_USER_ROLE:
      '角色是一组功能权限的集合，包括菜单访问权限和权限点，给用户分配角色后，用户即获得相应菜单的访问权限和权限点。',
    HOVER_USER_PERMISSION:
      '给用户分配组织结构上的节点，开启组织结构的“自动分配”资产权限后，组织结构内用户将自动获得下级节点访问权限。',
    HOVER_USER_STRUCTURE:
      '把多个用户分配到用户组中，给用户组统一分配资产权限后，同一个用户组内的用户拥有相同的资产访问权限。',
    TITLE_CONFIRM_REMOVE_ROLE: '移除角色',
    TITLE_CONFIRM_REMOVE_STRUCTURE: '移除组织结构',
    TITLE_CONFIRM_REMOVE_USER_GROUP: '移除用户组',
    WINMSG_DELETE_CHECK: '移除后，用户将不再获得相关权限。确定移除？',
    WINMSG_DELETE_ROLE_CHECK:
      '移除后，用户将不再获得角色相关权限。确定移除用户的角色？',
    WINMSG_DELETE_STRUCTURE_CHECK:
      '移除后，用户将不再获得组织结构相关权限。确定将用户从组织结构移除？',
    WINMSG_SUB_DELETE_STRUCTURE_CHECK:
      '移除后，用户将不再获得组织结构相关权限。同时，你对用户的管理权限也会被解除。确定将用户从组织结构移除？',
    WINMSG_DELETE_USERGROUP_CHECK:
      '移除后，用户将不再获得用户组相关权限。确定将用户从用户组移除？',
    PRMTMSG_REMOVE_SUCCEED: '角色移除成功',
    STRUCTURE_REMOVE_SUCCEED: '组织结构移除成功',
    USER_GROUP_REMOVE_SUCCEED: '用户组移除成功',
    PRMTMSG_MODIFY_USER_SUCCEED: '修改成功',
    COLH_DESCRIPTION: '描述',
    COLH_USER_ROLE: '角色',
    COLH_USER_STRUCTURE: '组织结构',
    COLH_USER_USER_GROUP: '用户组',
    MSG_ACCOUNT_NUMBER_REQUIRED: '请输入数字',
    TXT_SELECTED_STRUCTURE: '已选组织',
    MSG_EMAIL_NOT_SAME: '两次输入邮箱不一致',
    LABEL_NEW_CIPHER: '新密码',
    LABEL_OLD_CIPHER: '原密码',
    LABEL_CONFIRM_NEW_CIPHER: '确认新密码',
    MSG_NO_CIPHER: '密码不能为空',
    MSG_ENTER_OLD_CIPHER: '请输入原密码',
    MSG_ENTER_NEW_CIPHER: '请输入新密码',
    MSG_NEW_CIPHER_NOT_SIMILAR: '两次输入密码不一致',
    MSG_NEW_OLD_CIPHER_SIMILAR: '新旧密码不能重复',
    MSG_MODIFY_CIPHER_SUCCESS: '修改密码成功',
    MSG_ACCOUNT_CANNOT_CHANGE: '账号的类型和来源将不可修改',
    MSG_CREATE_ADD_USER: '新建用户',
    MSG_INVALIDATE_CIPHER: '密码不符合规范',
    MSG_CIPHER_PATTERN:
      '密码必须同时包含大写字母、小写字母和数字（支持特殊字符!@#%&*$()[]{}|），且长度不少于8位',
    HINT_USER_REQUIRED: '用户账号不能为空',
    HINT_REGION_REQUIRED: '管理范围不能为空',
    MSG_SUB_ADMIN_ADD_EXIST_USER: '此用户已存在企业中，无法添加',
    TITLE_USER_BATCH_IMPORT: '批量导入',
    BTN_BATCH_IMPORT: '批量导入',
    MSG_DOWNLOAD_IMPORT_TEMPLATE: '下载导入模板',
    MSG_UPLOAD_WRITTEN_FILE: '上传填写的文件',
    MSG_A_IMPORT_TEMPLATE_DOWNLOAD: '下载模板',
    BTN_UPLOAD_SELECT: '选择文件',
    BTN_START_UPLOAD: '开始上传',
    BTN_UPLOADING: '上传中',
    BTN_PROCESSING: '正在处理中',
    TITLE_BATCH_IMPORT_EXPLANATION:
      '下载导入模板，填写表格并成功上传后，即可批量添加用户并分配角色和组织',
    MSG_A_BATCH_IMPORT_EXPLANATION:
      '导入数据量上限为1000条，文件大小为2M，支持格式为{0}',
    TITLE_RECENT_FAILED_RECORD: '最近导入记录',
    MSG_A_DOWNLOAD_FAILED_IMPORT_RECORD: '下载导入失败记录',
    TITLE_UPLOAD_FILE_SIZE_ERROR: '上传文件大小错误',
    TITLE_UPLOAD_FILE_ERROR: '上传文件错误',
    TITLE_UPLOAD_FILE_FORMAT_ERROR: '上传文件格式错误',
    MSG_UPLOAD_FILE_FORMAT_ERROR: '请上传.xls或.xlsx为后缀的表格类型文件！',
    MSG_UPLOAD_FILE_SIZE_ERROR: '请上传文件大小小于2M的表格类型文件！',
    MSG_HISTORY_SUCCESS_RECORDS: '你于{0}导入成功{1}位成员',
    MSG_HISTORY_FAILED_RECORDS: ',失败{0}位成员',
    TITLE_TEMPLATE_NAME: '导入模板.xlsx',
    TITLE_HISTORY_RECORDS_NAME: '{0}_导入失败纪录.xlsx',
    LABEL_USER_TYPE: '类型',
    LABEL_USER_ACCOUNT_AD: '域账号',
    LABEL_USER_ACCOUNT_INTERNAL: '非域账号',
    LABEL_USER_SOURCE: '来源',
    MSG_CIPHER_RULES: '密码规则: {0}',
    TITLE_CONFIRM_RESET_CIPHER: '确认重置密码',
    MSG_CONFIRM_RESTE_CIPHER: '系统将自动生成新密码。确认重置密码？',
    MSG_NOTICE_CONTENT:
      '系统无法自动发送邮件，请将系统登录网址及账号密码通知用户',
    BTN_COPY_ACCOUNT_CIPHER: '复制',
    TXT_CORY_SUCCESS: '用户名和密码复制成功',
    TITLE_RESET_CIPHER_SUCCESS: '重置密码成功',
    TITLE_CREATE_ADD_ACCOUNT_SUCCESS: '账号创建并添加',
    HINT_INCORRECT_PHONE_NUMBER: '手机号码格式不正确，请重新输入',
    PLACEHOLD_SELECT_USER: '请选择',
    COLH_ACCOUNT_START_TIME: '有效自',
    HINT_ACCOUNT_START_TIME: '账号从该日期生效，才能登录进该OU',
    COLH_ACCOUNT_EXPIRE_TIME: '有效至',
    HINT_ACCOUNT_EXPIRE_TIME: '账号在该日到期后，无法再登录进该OU',
    BTN_BATCH_EXPORT: '批量导出',
    TITLE_BATCH_EXPORT: '批量导出',
    COLH_CREATE_TIME: '创建时间',
    TITLE_COMPANY: '公司',
    TITLE_DEPARTMENT: '部门',
    TITLE_POSITION: '职位'
  },
  SUB_ADMIN: {
    COLH_NAME: '账号',
    COLH_MANAGEMENT_REGION: '管理范围',
    COLH_AVAILABLE_ROLE: '可管理角色',
    BTN_MANAGE: '管理',
    BTN_REMOVE_FROM_OU: '移除',
    TITLE_REMOVE_SUB_ADMIN: '移除子管理员',
    TEXT_REMOVE_SUB_ADMIN:
      '移除后，该用户的管理权限将被解除。确认移除子管理员？',
    TITLE_REMOVE_FAIL: '移除子管理员失败',
    MSG_REMOVE_SUCCESS: '子管理员移除成功',
    BTN_CREATE_SUB_ADMIN: '添加子管理员',
    TEXT_COMMA: '、',
    TITLE_PAGE_NAME: '子管理员',
    TITLE_NEW_SUB_ADMIN: '添加子管理员',
    TITLE_MANAGE_SUB_ADMIN: '管理子管理员',
    INLINE_SUB_ADMIN_DETAIL_HINT:
      '子管理员可以在特定组织结构范围内，管理相应的人员权限，比如分配角色和分配资产访问权限。',
    TITLE_SELECT_USER: '选择用户',
    TITLE_SET_REGION: '设置管理范围',
    TITLE_SELECT_ROLE: '选择可管理角色',
    TEXT_REGION_HINT:
      '为子管理员配置可以管理的组织结构节点范围，设置后，子管理员只可以给管理范围内的人员分配角色和资产访问权限。',
    TEXT_ROLE_HINT: '选择子管理员可以分配给用户的角色范围。',
    BTN_SUBMIT: '提交',
    HINT_SELECT_USER: '输入用户账号进行查找',
    HINT_SET_REGION: '选择可管理的组织结构',
    HINT_SELECT_ROLE: '选择可管理的角色',
    HINT_NO_MATCH_DATA: '无匹配结果',
    HINT_USER_REQUIRED: '用户账号不能为空',
    HINT_REGION_REQUIRED: '管理范围不能为空',
    MSG_CREATE_SUCCESS: '添加子管理员成功',
    MSG_UPDATE_SUCCESS: '子管理员编辑成功',
    BTN_VIEW: '查看',
    COLH_MANAGEMENT_AUTHORITY: '管理权限',
    COLH_ALLOCATION: '分配方式',
    COLH_ASSIGNED_MANAGEMENT_REGION: '可管理范围',
    TXT_SUBADMIN_NAME: '子管理员账号',
    TITLE_SELECT_SUB_ADMIN: '子管理员用户',
    HINT_SELECT_ALLOCATION: '选择分配方式',
    HINT_SELECT_REGION: '选择可管理的范围',
    TITLE_SELECT_FUNCTION: '可选功能',
    TXT_APPLICATION: '应用管理', // 目前后端提供
    TXT_USER: '用户管理', // 目前后端提供
    TXT_ROLE: '角色管理', // 目前后端提供
    TXT_USER_GROUP: '用户组管理', // 目前后端提供
    TXT_ASSET_PERMISSION: '资产权限分配', // 目前后端提供
    TXT_AUDIT_LOG: '审计记录', // 目前后端提供
    TXT_ASSIGNED_BY_ORGANIZATION_STRUCTURE: '按组织结构分配',
    TXT_ASSIGNED_BY_USER_GROUP: '按用户组分配',
    TXT_ASSIGNED_BY_ROLE: '按角色分配',
    BTN_ADD: '添加分配方式',
    TXT_DELETE_CONFIRM: '确认删除该分配方式？',
    MSG_DELETE_CONFIRM: '子管理员将失去该部分管理范围的权限，确认删除？',
    HINT_APPLICATION: '子管理员可以使用应用的菜单组管理功能', // 目前后端提供
    HINT_USER: '子管理员可以创建、编辑、删除账号，可以进行批量导入、导出操作，并且可以给用户分配角色、用户组、组织结构', // 目前后端提供
    HINT_ROLE: '可以管理子管理员自己创建的和分配给子管理员的角色', // 目前后端提供
    HINT_USER_GROUP: '可以管理子管理员自己创建的和分配给子管理员的用户组', // 目前后端提供
    HINT_ASSET_PERMISSION: '子管理员可以按用户组、按用户给管理的用户分配资产权限', // 目前后端提供
    HINT_AUDIT_LOG: '子管理员可以查看、导出自己的权限管理事件，以及所管理的用户的登录、登出事件', // 目前后端提供
    HINT_ALLOCATIONS: '初始化分配给子管理员可管理的用户、资产和角色',
    HINT_OPERATIONS: '子管理员可以使用的功能',
    TXT_STRUCTURES: '组织结构',
    TXT_ROLES: '角色',
    TXT_USER_GROUPS: '用户组'
  },
  ASSET_PERMISSION: {
    TXT_USER: '按用户',
    TXT_USER_GROUP: '按用户组',
    HINT_SEARCH: '输入账号查找',
    HINT_USER_SEARCH: '请输入账号或邮箱查找',
    HINT_USER_GROUP_SEARCH: '输入用户组名称查找',
    BTN_MANAGE_ASSET: '管理资产',
    COLH_NAME: '已分配资产',
    TITLE_MANAGE_ASSET: '管理资产',
    TXT_ASSGIN_TO: '分配到',
    TITLE_CONFIRM_REMOVE: '移除资产',
    ASSET_PERMISSION_USER: '移除后，用户将不再获得资产相关权限。确定移除资产？',
    ASSET_PERMISSION_USER_GROUP: '移除后，用户组将不再获得资产相关权限。确定移除资产？',
    UNASSIGNED_ASSET: '未分配资产',
    ASSIGNED_ASSET: '已分配资产',
    INLINE_ASSET_PERMISSION_DETAIL_HINT:
      '可以为用户或者用户组，分配可以管理的资产范围。设置完成后，用户即可通过应用看到相关资产数据。'
  },
  ASSET_TREE: {
    BTN_MANAGE: '管理',
    BTN_SYNC_ING: '正在同步',
    TITLE_PAGENAME: '管理组织结构',
    COLH_ASSET_NAME: '资产名称',
    COLH_SYNC_TIME: '同步时间',
    TITLE_ASSET_SYNC:
      '资产同步是将本组织已接入并打标签的资产，从开发者平台同步到应用门户，同步完成后，才可为用户分配资产权限.',
    MSG_SYNC_ASSET_TREE_FAIL: '请稍后再试',
    MSG_SYNC_ASSET_TREE_SUCCESS: '同步成功',
    MSG_PROMPT_ASSETS_ALLOCATION:
      '为保证安全，分配资产后，用户将在3分钟后获得相应的资产权限.'
  },
  OU: {
    TITLE_INFO: '基本信息',
    TITLE_ADMIN: 'OU管理员',
    TITLE_PERSONALITY: '个性化',
    TITLE_OU_NAME: 'OU名称',
    TITLE_OU_ADDRESS: '地址',
    TITLE_INDUSTRY: '所属行业',
    TITLE_LOGO: '上传Logo',
    TITLE_ADMIN_ACCOUNT: '管理员账号',
    TITLE_ADMIN_NAME: '管理员姓名',
    BTN_CHANGE_MANAGER: '更换管理员',
    TITLE_CHANGE_MANAGER: '更换管理员',
    LABEL_CURRENT_ADMIN: '当前管理员',
    LABEL_NEW_ADMIN: '新管理员',
    TITLE_CHANGE_ADMIN: '更换管理员',
    WINMSG_CHANGEADMIN_HINT1: '将授权用户{0}为新管理员。',
    WINMSG_CHANGEADMIN_HINT2: '并且同时，你将不再是管理员。',
    WINMSG_CHANGEADMIN_HINT3: '确认更换管理员？',
    HINT_NO_MATCH_DATA: '暂无数据，请输入正确账号',
    HINT_INPUT_HINT: '输入用户账号或邮箱进行查找',
    INLINE_NEEDED: '新管理员不能为空',
    BTN_REUPLOAD: '重新上传',
    MSG_FILE_UPLOAD_SUCCEED: '上传成功',
    TXT_CHANGE_LOGO_HINT:
      'Logo图片将显示于顶部导航栏，建议使用200*32像素的透明底的PNG，SVG格式图片。',
    TXT_SEARCH: '输入OU名称查询',
    TITLE_LANGUAGE_SETTING: '语言设置',
    TITLE_LANGUAGE: '当前语言',
    TXT_EDIT: '编辑',
    TITLE_LAN_SETTING: '语言设置',
    HINT_EDIT_LAN_HINT: '语言设置将对企业/组织内的所有用户生效',
    HINT_LANG_SETTING_SUCCEED: '语言设置成功',
    TITLE_PAGEFOOTER: '页脚信息',
    TITLE_EDITPAGEFOOTER: '编辑页脚信息',
    MSG_NULLFOOTER: '页脚信息为空',
    TXT_NULL: '(空)',
    MSG_EDITPAGEFOOTER_SUCCESS: '保存页脚信息成功',
    HINT_NOTBUY: '当前OU未购买该功能'
  },
  PORTAL: {
    BTN_ADMIN_CONSOLE: '进入管理后台',
    TITLE_IFRAME_ERROR: '嵌入错误',
    MSG_INVALIDATE_URL: '菜单地址不符合规范',
    MSG_LOADING_FRAME: '内容加载中...',
    NO_APP: '暂无任何应用使用权限',
    BTN_CHANGE_APP: '切换应用'
  },
  SUPER: {
    TITLE_ASSIGN_OU_ADMIN: '分配管理员',
    TITLE_RESET_ADMIN_CIPHER: '重置管理员密码',
    TITLE_CONFIRM_RESET_CIPHER: '确认重置管理员密码？',
    MSG_CONFIRM_RESET_CIPHER: '系统将发送重置管理员密码邮件至邮箱:',
    MSG_CREATE_USER_AS_ADMIN: '新建用户为管理员',
    MSG_CONFIRM_SET_ADMIN: '确认设置为管理员？',
    TXT_CONFIRM_SET_ADMIN:
      '分配用户 {0} 为管理员，系统将发送邀请邮件至：{1}, 确认发送?',
    TXT_EDGE_CONFIRM_SET_ADMIN: '分配用户 {0} 为管理员, 确认分配?',
    TITLE_OU_NAME: 'OU名称',
    TITLE_CURRENT_OU: '当前管理员',
    TITLE_NOT_ASSIGN: '(尚未分配管理员)',
    MSG_CONFIRM_CHANGE_ADMIN: '确认更换管理员？',
    TXT_CONFIRM_CHANGE_ADMIN1: '管理员将由当前用户 {0} 更改为 {1}',
    TXT_CONFIRM_CHANGE_ADMIN2: '系统将发送邀请邮件至：{0}, 确认发送？',
    MSG_SEND_EMAIL_SUCCESSFULLY: '发送邮件成功'
  },
  PLUGIN: {
    BTN_REGISTER_PLUGIN: '注册插件',
    TITLE_PLUGIN_NAME: '名称',
    TITLE_NAME_DEFAULT: '名称',
    TITLE_NAME_ENGLISH: '名称（英文）',
    TITLE_URL: '指向URL',
    TITLE_DESCRIPTION: '描述',
    BTN_ASSIGN_OU: '分配OU',
    HINT_ADD_PLUGIN_NAME_PLACEHOLDER: '请输入',
    HINT_ADD_PLUGIN_URL_PLACEHOLDER: '请输入有效URL',
    BTN_CANCELTEXT: '取消',
    BTN_OKTEXT: '提交',
    TITLE_MODAL_REGISTER_PLUGIN: '注册插件',
    TITLE_MODAL_MODIFY_PLUGIN: '编辑插件',
    TITLE_MODAL_ASSIGN_OU: '分配OU',
    TITLE_MODAL_DELETE_PLUGIN: '删除插件',
    CONTENT_MODAL_DELETE_PLUGIN: '删除插件后，不可恢复，确认删除？',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED1: '该插件已分配用户，无法删除',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED2: '如仍需删除，请先移除已分配OU',
    INPUT_NAME_NEEDED: '请输入名称',
    INPUT_NAME_CHINESE_NEEDED: '请输入名称（中文）',
    INPUT_NAME_ENGLISH_NEEDED: '请输入名称（英文）',
    INPUT_URL_NEEDED: '请输入URL',
    INPUT_DESCRIPTION_NEEDED: '请输入描述',
    MESSAGE_REGISTER_SUCCEED: '注册插件成功',
    MESSAGE_MODIFY_SUCCEED: '编辑插件成功',
    MESSAGE_ASSIGN_OU: '分配OU成功',
    MESSAGE_DELETE_SUCCESS: '插件已删除',
    MSG_ASSIGN_OU: '分配给OU后，OU的管理员将可以使用此插件',
    TXT_OU: 'OU',
    TXT_SELECTED_OU: '已选OU'
  },
  MESSAGE: {
    TITLE_NAME: '消息通知',
    TXT_SHOW_ALL: '查看全部',
    TXT_NO_MESSAGE: '暂无消息',
    TXT_TO_SOUND: '点击开启声音',
    TXT_TO_MUTE: '点击关闭声音',
    TXT_DISABLE_DIALOG: '点击关闭弹窗',
    TXT_DIALOG: '点击开启弹窗',
    TXT_CLOSE_DIALOG: '关闭',
    TXT_APP_HINT1: '还有{0}个应用，{1}个告警',
    TXT_APP_HINT2: '收起',
    TXT_MESSAGE: '消息',
    TXT_LOAD_MORE: '加载更多',
    TXT_LOADING: '正在加载',
    TXT_LOAD_FAILED: '加载失败，请点击重试'
  },
  DOMAIN: {
    BTN_ADD_DOMAIN: '添加域',
    TXT_DOMAIN_NAME: '域名称',
    TXT_DOMAIN_URL: 'URL',
    TXT_DOMAIN_DESCRIPTION: '描述',
    TITLE_ADD_DOMAIN: '添加域',
    MESSAGE_ADD_SUCCEED: '添加成功',
    TITLE_MODIFY_DOMAIN: '编辑域',
    MESSAGE_MODIFY_SUCCEED: '域信息编辑成功',
    TITLE_MODAL_DELETE_DOMAIN: '删除域',
    CONTENT_MODAL_DELETE_DOMAIN: '删除域后，域信息将不可恢复，确认删除？',
    MESSAGE_DELETE_SUCCESS: '域删除成功',
    HINT_ADD_URL_PLACEHOLDER: '请输入有效URL',
    TXT_ADD_DOMAIN: '为该OU添加域名后，新建本OU域账号时，可选择域所属域名',
    TXT_DOMAIN_NAME_NEEDED: '域名称不可为空',
    TXT_DOMAIN_URL_NEEDED: '域的URL不可为空',
    TXT_AUTO_IMPORT: '自动导入用户', // TODO
    TXT_YES: '是', // TODO
    TXT_NO: '否', // TODO
    TXT_ROLES: '角色',
    TXT_USER_GROUPS: '用户组',
    TXT_SELECT_ROLES: '请选择角色', // TODO
    TXT_SELECT_USERGROUPS: '请选择用户组', // TODO
    HINT_NOT_AUTO_IMPORT: '手动创建 EnOS 用户以进行单点登录', // TODO
    HINT_AUTO_IMPORT: 'EnOS 应用门户支持用户单点登录时，自动导入用户并分配指定角色和用户组。“是”，自动导入通过单点登录的用户并分配角色和用户组；“否”，需提前手动创建用户，否则无法正常登录。', // TODO
    HINT_AUTO_IMPORT_NECESSARY: '自动导入用户不可为空', // TODO
    TITLE_DOUBLE_CHECK: '确认禁用自动导入用户？', // TODO
    TXT_DOUBLE_CHECK: '禁用自动导入用户后，你需要提前在应用门户中创建新用户以进行单点登录，现有用户的角色和用户组信息不受影响。' // TODO
  },
  SECURITY: {
    TAB_CIPHER_RULES: '密码规则',
    TAB_LOGIN_SECURITY: '登录安全',
    MSG_CIPHER_RULES: '以下密码规则对该环境下，所有非域账号用户生效',
    MSG_LOGIN_SECURITY: '以下登录安全规则，对该环境下所有用户生效',
    LABEL_CIPHER_REQUIRED: '密码中必须包含',
    TITLE_CIPHER_REQUIRED: '至少勾选一项',
    LABEL_CIPHER_LENGTH: '密码长度',
    LABEL_CIPHER_LENGTH_AFTER: '个字符',
    LABEL_CIPHER_LENGTH_BOTTOM: '可设置长度范围8-20',
    LABEL_CIPHER_RETRY_CONSTRAINT: '重试约束',
    LABEL_CIPHER_RETRY_CONSTRAINT_AFTER: '次/小时',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: '限制一小时内密码重试错误次数，密码重试超过约束次数将自动锁定1小时，可设置范围1-10',
    LABEL_REPEAT_TIMES: '重复限制',
    LABEL_REPEAT_TIMES_AFTER: '次',
    LABEL_REPEAT_TIMES_BOTTOM: '用户重置/修改密码时，限制新密码不可与前N次历史密码重复，可设置前1-5次',
    LABEL_SINGLE_OR_MORE: '允许单账号多会话登录',
    LABEL_SINGLE_OR_MORE_BOTTOM: '开启后，允许同账号可以多会话同时登录',
    TITLE_OPEN_MORE_LOGIN: '确认开启',
    CONTENT_OPEN_MORE_LOGIN: '开启选项后，将允许同账号同时多会话登录',
    TITLE_CLOSE_MORE_LOGIN: '确认关闭',
    CONTENT_CLOSE_MORE_LOGIN: '关闭选项后，用户在登录状态时，如果同账户再次登录，已登录用户将被登出，并提示安全风险',
    LABEL_SESSION_VALID_TIME: '登录session有效时间',
    LABEL_SESSION_VALID_TIME_AFTER: '分钟',
    LABEL_SESSION_VALID_TIME_BOTTOM: '用户登录时，一定时间内无操作，即超时退出，可设置的时间范围是15-720分钟',
    LABEL_IP_ADDRESS: 'IP地址黑白名单',
    LABLE_IP_ADDRESS_WHITE: '白名单',
    LABEL_IP_ADDRESS_BLACK: '黑名单',
    PLACEHOLD_IP_ADDRESS: '多个地址请用英文“,”分隔',
    LABEL_IP_ADDRESS_BOTTOM_WHITE: '白名单：设置白名单后，只允许白名单的IP地址登录，仅对非域账号用户生效',
    LABEL_IP_ADDRESS_BOTTOM_BLACK: '黑名单：设置黑名单后，不允许黑名单内IP地址登录，仅对非域账号用户生效',
    TITLE_SWITCH_IP_LIST_MODAL: '切换确认',
    CONTENT_SWITCH_IP_LIST_MODAL: '切换名单后，已输入内容将无法保留，是否切换？',
    TITLE_ILLEGAL_IP: '非法的IP地址或(CIDR)IP段',
    TITLE_LENGTH_BEYOND: '不可超过500个',
    TXT_LENGTH_HINT: '长度{0}-20个字符',
    TXT_UPPERCASE_HINT: '必须包含大写字母',
    TXT_LOWERCASE_HINT: '必须包含小写字母',
    TXT_MUNBER_HINT: '必须包含数字',
    TXT_SPECIAL_CHARACTER_HINT: '必须包含特殊字符（!@#%&*()[]{}-_=|）',
    MESSAGE_SET_CIPHER_RULES_SUCCESS: '密码规则设置成功',
    MESSAGE_SET_SECURITY_LOGIN_SUCCESS: '登录安全设置成功',
    TXT_CIPHER_TYPE_NUMBER: '数字',
    TXT_CIPHER_TYPE_UPPERCASE: '大写字母',
    TXT_CIPHER_TYPE_LOWERCASE: '小写字母',
    TXT_CIPHER_TYPE_CHARACTER: '特殊字符（!@#%&*()[]{}-_=|）',
    BTN_SUBMIT_SECURITY: '应用修改'
  },
  AUDIT: {
    TXT_AUDIT_LOG: '以下列表记录了过去{0}天内，OU内所有用户，登录、登出、对系统配置的行为',
    BTN_EXPORT: '导出',
    BTN_EXPORT_LOADING: '正在导出',
    TITLE_EVENT_TIME: '事件时间',
    TITLE_ACCOUNT: '用户账号',
    TITLE_EMAIL: '邮箱',
    TITLE_ACCOUNT_TYPE: '账号属性',
    TITLE_ASSET_TYPE: '资源类型',
    TITLE_EVENT_NAME: '事件名称',
    TITLE_EVENT_DESCRIPTION: '事件描述',
    TITLE_IP_ADDRESS: 'ip地址',
    TITLE_OPERATION: '操作',
    TITLE_SEARCH_ACCOUNT: '搜索账号',
    BTN_SEARCH_ACCOUNT: '搜索',
    BTN_RESET_ACCOUNT: '重置',
    BTN_VIEW_CONTENT: '详情',
    TXT_SEMICOLON: '；',
    TITLE_MODAL_DETAIL: '事件详情',
    TITLE_MODAL_EXPORT: '确认导出',
    TXT_MODAL_EXPORT1: '确认导出所选时间段内的审计记录？',
    TXT_MODAL_EXPORT2: '如需导出{0}天前的数据，请联系系统管理员',
    TITLE_DETAIL_EDIT_BEFORE: '编辑前',
    TITLE_DETAIL_EDIT_AFTER: '编辑后',
    TITLE_EXPORT_AUDIT_LOG: '审计记录_{0}.xlsx',
    TITLE_DOWNLOAD_AUDIT_LOG: '下载导入记录'
  },
  OU_SECURITY: {
    TXT_MFA: '多因子认证',
    TXT_LOGIN_PROTECTION: '登录保护',
    BTN_SUBMIT_SECURITY: '应用修改',
    TXT_CLOSE_LOGIN_PROTECTION: '未开启',
    TXT_OPEN_EMAIL_AUTH: '开启邮箱验证',
    TXT_EMAIL_AUTH_HINT:
      '系统将在OU内用户登录时通过邮箱进行二次验证，以保证用户的账号安全',
    TXT_LOGIN_VALIDATE: '登录验证',
    LABEL_EMAIL_ADDRESS: '验证邮箱地址',
    LABEL_VERITIFICATION_CODE: '验证码',
    BTN_SEND_CODE: '发送验证码',
    TXT_INPUT_CODE: '请输入验证码',
    TXT_BACK_TO_LOGIN: '返回登录',
    HINT_CODE_SENDED: '发送成功，请前往邮箱查看',
    HINT_WRONG_CODE: '验证码错误，请重新输入',
    HINT_CODE_REQUIRED: '请输入验证码',
    BIN_RESEND_CODE: '重新发送',
    PRMTMSG_SEND_CODE_SUCCEED: '多因子认证设置成功',

    MSG_CIPHER_RULES: '以下密码规则对该OU下，所有非域账号用户生效',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: '限制一小时内密码重试错误次数，密码重试超过约束次数将自动锁定{0}分钟，可设置范围1-10',
    LABEL_REPEAT_TIMES_BOTTOM: '用户重置/修改密码时，限制新密码不可与前N次历史密码重复，可设置前1-5次',
    LABEL_SESSION_VALID_TIME_AFTER: '小时',
    LABEL_SESSION_VALID_TIME_BOTTOM: '用户登录时，一定时间内无操作，即超时退出，可设置的时间范围是1-240小时',
    TXT_SESSION_VALID_TIME: '登录有效时间'
  },
  ALARM: {
    COLH_ORIGIN: '来源',
    TXT_EMPTY: '无数据',
    TXT_ACTIVE_ALARM: '活动告警',
    TXT_GOTO_LIST: '前往告警列表',
    COLH_SEV: '等级',
    COLH_ALARMTYPE: '告警类型',
    COLH_SITE: '场站',
    COLH_SITETYPE: '场站类型',
    COLH_DEVICE: '设备',
    COLH_DEVICETYPE: '设备类型',
    COLH_CPTTYPE: '部件类型',
    COLH_COMPONENT: '部件',
    COLH_CONTENT: '内容',
    COLH_START: '开始时间',
    COLH_END: '结束时间',
    TXT_LAST_UPDATE: '最后更新于',
    TXT_ENABLE_SOUND: '开启声音',
    TXT_DISABLE_SOUND: '关闭声音',
    TXT_ENABLE_POP: '启用弹窗',
    TXT_DISABLE_POP: '禁止弹窗',
    TXT_REFRESH: '刷新',
    TXT_ACK: '确认',
    TXT_ACKED: '已确认',
    COLH_DUR: '持续时间',
    COLH_OPERATION: '操作',
    TXT_ALL: '全部 ({0})'
  },
  LANDING_PAGE: {
    LABEL_SITE_TIME: '场站时间',
    HINT_CUSTOMIZE: '自定义',
    BTN_ADD_WIDGET: '添加组件',
    BTN_SAVE: '保存',
    BTN_EXIT: '退出',
    PLACEHOLD_SEARCH_NAME: '按名称搜索',
    TXT_NO_MATCH: '暂无匹配结果',
    BTN_ADD_TO_PAGE: '添加到页面',
    TITLE_EXIT_CONFIRM: '确认退出编辑模式？',
    TXT_UNSAVE_TIP: '将丢失未保存配置',
    BTN_CANCEL: '取消',
    MSG_FAILED_TO_GET_ASSET: '获取资产树失败',
    TXT_DAY: '日',
    TXT_MONTH: '月',
    TXT_YEAR: '年',
    TXT_MTD: '当月',
    TXT_30d: '最近30天',
    TXT_QTD: '当季',
    TXT_3m: '最近3个月',
    TXT_YTD: '当年',
    TXT_12m: '最近12个月',
    TXT_Custom: '自定义',
    LABEL_TIME_INTERVAL: '时间间隔：',
    LABEL_SITEM_SELECTED: '场站：已选（{0}）'
  }
};

export default locale;
